import { ACCENT_COLOR } from "../../lib/utils/constants";

export const DEFAULT_DOWNLOAD_FILENAME = "logs.tar.gz";
export const DOWNLOAD_RESET_DELAY = 100;
export const DATE_FORMAT_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const LOG_HEADER_SX = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  mb: 0.5,
  flexWrap: "wrap",
};

export const LOG_ALERT_SX = {
  minHeight: "40px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  backgroundColor: "#fff",
  color: "#6b7280",
  borderColor: "rgba(0, 0, 0, 0.23)",
  padding: "8px 12px",
  "& .MuiAlert-icon": { color: "#6b7280", marginRight: "8px" },
  "& .MuiAlert-message": { color: "#6b7280", fontSize: "0.875rem", padding: 0, lineHeight: 1.5 },
};

export const LOG_REQUEST_BTN_SX = {
  textTransform: "none",
  borderColor: "#d1d5db",
  borderRadius: "10px",
  color: "#374151",
  fontWeight: 600,
  fontSize: "0.8rem",
  px: 2,
  py: 0.7,
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: ACCENT_COLOR,
    backgroundColor: "var(--color-accent-lightest)",
    color: ACCENT_COLOR,
  },
};

export const LOG_DOWNLOAD_BTN_SX = {
  color: "#1976d2",
};
